<template>
  <div class="gp-content releases">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Releases',
};
</script>

<style lang="scss" scoped>
.releases {
  height: 100%;
}
</style>
